import { SalesOrderStatus } from '../../constants/sales-order-status.js';
/** Statuses where `date_first_ship` is a delivery; before Shipped it holds the planned ship date (N31). */
export const DELIVERED_SALES_ORDER_STATUS_IDS = new Set([
    SalesOrderStatus.SHIPPED,
    SalesOrderStatus.COMPLETE,
]);
//# sourceMappingURL=delivered-sales-order-status-ids.js.map